import {
  ts_runthetrickstrat,
  ts_social,
  gears_procircuit,
  gears_gowrostermania,
  lb_dreamhack,
  ts_rs6
} from './promo_paths';

export const PROMOS = {
  0:ts_runthetrickstrat,
  1:ts_social,
};

export const GEARS_PROMOS = {
  0:gears_procircuit,
  1:gears_gowrostermania,
};

export const LAWBREAKERS_PROMOS = {
  0:lb_dreamhack,
};
export const RS6_PROMOS = {
  0:ts_rs6,
};



// WEBPACK FOOTER //
// ./src/app/utils/promos/promoArrays.js